<template>
    <div class="study-activity-mini" v-if="activity && hasActivity">
        <section-header title="Study Activity" icon="fa-calendar-days"/>
        <!-- Same card anatomy as the enrollment / conference tiles: body,
             optional alert strip, shaded CTA footer -->
        <div class="info-box is-card is-no-icon">
            <div class="box-main">
                <div class="box-body">
                    <activity-heatmap
                        :days="activity.days"
                        :weeks="activity.weeks"
                        :range-from="activity.range.from"
                        :range-to="activity.range.to"
                    />
                    <div class="box-text mt-3"><i class="far fa-fw fa-clock mr-2"></i><strong>{{ last30Hours }}</strong> hours logged in the last 30 days</div>
                </div>
            </div>
            <div class="box-alert" :class="{'is-danger': reviewState === 'audit_risk'}" v-if="reviewState !== 'normal'">
                <i class="fas fa-fw fa-triangle-exclamation mr-2"></i>
                <template v-if="reviewState === 'audit_risk'">Please review your study log &mdash; several days look unusual.</template>
                <template v-else>Unusual activity on your account &mdash; review your study log details.</template>
            </div>
            <div class="box-actions">
                <div class="box-buttons">
                    <b-button tag="router-link" :to="{name: 'study-activity'}" type="is-primary" size="is-small"><i class="fas fa-calendar-days mr-2"></i>View Study Activity</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import {axiosInstance} from "../../http_client";
    import SectionHeader from "../framework/SectionHeader";
    import ActivityHeatmap from "../studyActivity/ActivityHeatmap";

    /**
     * Three-month heatmap plus one number. Renders the heatmap directly
     * rather than the full StudyActivityPanel (legend, schedule strip,
     * flagged-day list belong on the Study Activity page). Hidden until the
     * student has logged something.
     */
    export default {
        name: "StudyActivityMini",
        components: {SectionHeader, ActivityHeatmap},
        data() {
            return {activity: null};
        },
        computed: {
            reviewState() {
                return (this.activity.review && this.activity.review.state) || 'normal';
            },
            hasActivity() {
                return (this.activity.days || []).some(d => d.mins > 0);
            },
            last30Hours() {
                const cutoff = moment().subtract(30, 'days').format('YYYY-MM-DD');
                const mins = (this.activity.days || []).filter(d => d.date >= cutoff).reduce((s, d) => s + (d.mins || 0), 0);
                return Math.round(mins / 60 * 10) / 10;
            }
        },
        methods: {
            async load() {
                try {
                    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    // axiosInstance, not the cachios client: a ttl of 0 would
                    // cache this forever (same gotcha as StudyActivityPanel)
                    const {data} = await axiosInstance.get('app/study-activity', {params: {tz, months: 3}});
                    this.activity = data;
                } catch (err) {
                    this.activity = null;
                }
            }
        },
        mounted() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    // Layout comes from the global .info-box.is-card (assets/scss/_cta.scss)
    .box-text {
        color: #4a4a4a;

        i {
            color: #7d8794;
        }
    }
</style>
